/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
import schema_properties from '@bingads-webui-component-legacy/grid/schema/properties';
import Response from '@bingads-webui-component-legacy/grid/model/response';
var Model = BaseProjection.extend({
  defaults: {
    'column.i18n': {
      '': function (name) {
        return name;
      }
    }
  },
  name: 'column-i18n',
  beforeSet: function (local, other) {
    if (_.has(local, 'column.i18n')) {
      if (!_.isObject(local['column.i18n'])) {
        local['column.i18n'] = this.defaults['column.i18n'];
      }
    }
  },
  update: function (options) {
    if (Model.__super__.update.call(this, options)) {
      var model = this.src.data, col_options = this.get('column.i18n'), select = _.size(model.get('columns')) ? _.map(model.get('columns'), function (i) {
        return i.property;
      }) : model.get('select'), lookup = {}, $default = col_options[''];
      _.each(model.get('columns'), function (element, index, list) {
        lookup[element.property] = element;
      });
      var i18n_columns = _.map(select, function (element, index, list) {
        var opt = col_options[element];
        if (_.isUndefined(opt)) {
          opt = $default;
        }
        return _.defaults({
          $text: _.isFunction(opt) ? opt(element) : opt,
          property: element
        }, lookup[element]);
      });
      this.patch({
        columns: i18n_columns
      });
    } else {}
  }
});
export default Model;

